import { useState } from "react"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Flex, Space, Typography } from "antd"
import { useForm } from "antd/es/form/Form"

import { authStore } from "@src/app/authStore"
import { notify } from "@src/app/components/notify"
import { CallBackUrlForm } from "@src/pages/settingsCallbackUrl/ui/CallBackUrlForm"
import { CallBackUrlTable } from "@src/pages/settingsCallbackUrl/ui/CallBackUrlTable"
import { catchErrors, settingsApi } from "@src/shared/api"

export const SettingsCallbackUrlPage = observer(() => {
  const { merchant, reload } = authStore

  const [form] = useForm()

  const [isLoading, setLoading] = useState(false)

  const onSubmit = (value: any) => {
    setLoading(true)

    settingsApi
      .createCallbackUrl(value)
      .then((res) => {
        if (res) {
          notify.success("Callback Payout URL has been added")
        }
      })
      .then(() => reload())
      .then(() => form.resetFields())
      .catch(catchErrors)
      .finally(() => {
        setLoading(false)
      })
  }

  const tableItems = computed(() => {
    if (merchant?.callback_url && merchant.callback_signature_key) {
      return [
        {
          callbackUrl: merchant.callback_url as string,
          signatureKey: merchant.callback_signature_key as string,
        },
      ]
    }

    return []
  }).get()

  return (
    <Flex gap={32} vertical>
      <Space direction="vertical" size={8}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          Add Callback Payout URL
        </Typography.Title>
        <Typography.Text>
          Add callback URL for receiving notifications about the status of
          payout if necessary. The format of the URL is
          "https://mysite.com/home/callback"
        </Typography.Text>
      </Space>

      <CallBackUrlForm form={form} submit={onSubmit} />

      {Boolean(tableItems.length) && (
        <CallBackUrlTable
          data={tableItems}
          loading={isLoading}
        ></CallBackUrlTable>
      )}
    </Flex>
  )
})
